import MagnifyingGlass from '../src/MagnifyingGlass';
export default MagnifyingGlass;
